import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TournamentPlayoffBracketComponent } from './tournament-playoff-bracket/tournament-playoff-bracket.component';
import { TournamentPlayoffGameComponent } from './tournament-playoff-game/tournament-playoff-game.component';
import { TournamentPlayoffGameDialogComponent } from './tournament-playoff-game-dialog/tournament-playoff-game-dialog.component';
import { ProgressModule, TooltipModule, UtilsModule } from '@mtgame/ui';
import { TournamentPlayoffWidgetComponent } from './tournament-playoff-widget.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UtilsModule,
    ProgressModule,
    TooltipModule,
  ],
  declarations: [
    TournamentPlayoffWidgetComponent,
    TournamentPlayoffBracketComponent,
    TournamentPlayoffGameComponent,
    TournamentPlayoffGameDialogComponent,
  ],
  exports: [
    TournamentPlayoffWidgetComponent,
    TournamentPlayoffBracketComponent,
    TournamentPlayoffGameComponent,
    TournamentPlayoffGameDialogComponent,
  ]
})
export class TournamentPlayoffWidgetModule {}
